// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"7bbb8b33","119":"a3236b5a","142":"7ed985ff","300":"84bcb9ba","398":"71a519ab","588":"a2ca67e8","754":"e50b6d92","958":"412574b8"}[chunkId] + ".chunk.js";
};